<template>
  <div class="min-h-screen bg-black flex flex-col items-center justify-center space-y-4 p-6">
    <a href="/" class="mb-8">
      <img src="/images/logo_testo.png" alt="StreetStock Logo" class="h-12" />
    </a>

    <h1 class="text-white text-2xl font-bold mb-6">Scegli il tuo store</h1>

    <div class="flex flex-col space-y-3 w-full max-w-xs">
      <!-- 🔹 Primo bottone: link al sito -->
      <a href="https://rdnstreetmarket.it" target="_blank" rel="noopener"
        class="btn-indigo w-full text-center py-3 rounded-xl font-semibold">
        RdnStreetMarket.it
      </a>
      
      <a v-for="s in stores" :key="s.city" :href="waLink(s.phone)" target="_blank" rel="noopener"
        class="btn-indigo w-full text-center py-3 rounded-xl font-semibold">
        {{ s.city }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Whatsapp',
  data() {
    return {
      stores: [
        { city: 'TRANI', phone: '3281144176' },
        { city: 'GRAVINA IN PUGLIA', phone: '3278791139' },
        { city: 'MAGLIE', phone: '3281668224' },
        { city: 'ROMA', phone: '3898207959' },
        { city: 'SAN GIOVANNI ROTONDO', phone: '3886524901' },
        { city: 'OSTUNI', phone: '3889250060' },
        { city: 'ANDRIA', phone: '3280720330' },
        { city: 'SAN BENEDETTO DEL TRONTO', phone: '3279952848' },
        { city: 'BARI', phone: '3891844456' },
      ],
    }
  },
  methods: {
    waLink(num) {
      const d = (num || '').replace(/\D/g, '')
      return `https://wa.me/39${d}` // prefisso +39
    },
  },
}
</script>

<style scoped>
.btn-indigo {
  @apply bg-indigo-600 hover:bg-indigo-700 text-white transition;
}
</style>
